import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
  pageRoot: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "24px 16px 48px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  sectionCard: {
    borderRadius: "12px",
  },
  sectionTitle: {
    fontWeight: 600,
  },
  sectionSubtitle: {
    marginTop: "4px",
  },
  sectionGrid: {
    marginTop: "8px",
  },
  formActions: {
    marginTop: "12px",
  },
  previewPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "260px",
    padding: "16px",
    background: "#f7f8fb",
    borderRadius: "12px",
    border: "1px solid #e6e8ef",
  },
  avatar: {
    width: 30,
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
  },
  text: {
    color: "white",
  },
  smartphone: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "300px",
    height: "600px",
    margin: "auto",
    border: "10px black solid",
    borderTopWidth: "49px",
    borderBottomWidth: "60px",
    borderRadius: "36px",
    overflow: "hidden",
    background: "black",
  },
  nav: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "32px",
    color: "white",
    background: "black",
    padding: "0 12px",
    boxSizing: "border-box",
  },
  battery: {
    marginLeft: "auto",
  },
  adFrame: {
    flex: 1,
    width: "100%",
    border: "none",
    background: "black",
  },
  content2: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

}));
